import { controls, currencyToNumber, grouped } from "../../controls";


const rp11 = {
  label: "Total Probable List",
  starting: true,
  url: "rp11",
  pageLabel: "Total Probable List",
  pageType: "history",
  filter: [

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Total Probable List",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    filterable: true,
    sortable: true,
    // defaultsTo: 0,
    pivot: true,
    extraRows: {
      location: "top",
      fields: [""],

    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },


      {
        Header: "Track The Child Name",
        accessor: "name",
      },
      {
        Header: "Father name",
        accessor: "fathers_name",

      },
      {
        Header: "Mother name",
        accessor: "mothers_name",

      },
      {
        Header: "Date Of Birth",
        accessor: "date_of_birth",
        Type: "date",
      },

    ]
  }
};

export default rp11;